import { createContext, useContext } from 'react';

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}

let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = { randomUUID };

function v4(options, buf, offset) {
    if (native.randomUUID && true && !options) {
        return native.randomUUID();
    }
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? rng();
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    return unsafeStringify(rnds);
}

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

var getId = function getId(key) {
  return function () {
    return api.get(key);
  };
};
var getUser = function getUser(key) {
  return function () {
    var cookie = api.get(key);
    return cookie ? JSON.parse(cookie) : undefined;
  };
};
var setId = function setId(key, local) {
  return function (value) {
    return local ? api.set(key, value) : api.set(key, value, {
      secure: true,
      expires: 365,
      domain: '.ownup.com'
    });
  };
};
var setUser = function setUser(key) {
  return function (accountId, properties) {
    return api.set(key, JSON.stringify({
      accountId: accountId,
      properties: properties
    }));
  };
};
var removeCookie = function removeCookie(key, local) {
  return function () {
    return local ? api.remove(key) : api.remove(key, {
      domain: '.ownup.com'
    });
  };
};

var cookieUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getId: getId,
    getUser: getUser,
    removeCookie: removeCookie,
    setId: setId,
    setUser: setUser
});

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var browserPonyfill = {exports: {}};

var hasRequiredBrowserPonyfill;

function requireBrowserPonyfill () {
	if (hasRequiredBrowserPonyfill) return browserPonyfill.exports;
	hasRequiredBrowserPonyfill = 1;
	(function (module, exports) {
		// Save global object in a variable
		var __global__ =
		(typeof globalThis !== 'undefined' && globalThis) ||
		(typeof self !== 'undefined' && self) ||
		(typeof commonjsGlobal !== 'undefined' && commonjsGlobal);
		// Create an object that extends from __global__ without the fetch function
		var __globalThis__ = (function () {
		function F() {
		this.fetch = false;
		this.DOMException = __global__.DOMException;
		}
		F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
		return new F();
		})();
		// Wraps whatwg-fetch with a function scope to hijack the global object
		// "globalThis" that's going to be patched
		(function(globalThis) {

		((function (exports) {

		  /* eslint-disable no-prototype-builtins */
		  var g =
		    (typeof globalThis !== 'undefined' && globalThis) ||
		    (typeof self !== 'undefined' && self) ||
		    // eslint-disable-next-line no-undef
		    (typeof commonjsGlobal !== 'undefined' && commonjsGlobal) ||
		    {};

		  var support = {
		    searchParams: 'URLSearchParams' in g,
		    iterable: 'Symbol' in g && 'iterator' in Symbol,
		    blob:
		      'FileReader' in g &&
		      'Blob' in g &&
		      (function() {
		        try {
		          new Blob();
		          return true
		        } catch (e) {
		          return false
		        }
		      })(),
		    formData: 'FormData' in g,
		    arrayBuffer: 'ArrayBuffer' in g
		  };

		  function isDataView(obj) {
		    return obj && DataView.prototype.isPrototypeOf(obj)
		  }

		  if (support.arrayBuffer) {
		    var viewClasses = [
		      '[object Int8Array]',
		      '[object Uint8Array]',
		      '[object Uint8ClampedArray]',
		      '[object Int16Array]',
		      '[object Uint16Array]',
		      '[object Int32Array]',
		      '[object Uint32Array]',
		      '[object Float32Array]',
		      '[object Float64Array]'
		    ];

		    var isArrayBufferView =
		      ArrayBuffer.isView ||
		      function(obj) {
		        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
		      };
		  }

		  function normalizeName(name) {
		    if (typeof name !== 'string') {
		      name = String(name);
		    }
		    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
		      throw new TypeError('Invalid character in header field name: "' + name + '"')
		    }
		    return name.toLowerCase()
		  }

		  function normalizeValue(value) {
		    if (typeof value !== 'string') {
		      value = String(value);
		    }
		    return value
		  }

		  // Build a destructive iterator for the value list
		  function iteratorFor(items) {
		    var iterator = {
		      next: function() {
		        var value = items.shift();
		        return {done: value === undefined, value: value}
		      }
		    };

		    if (support.iterable) {
		      iterator[Symbol.iterator] = function() {
		        return iterator
		      };
		    }

		    return iterator
		  }

		  function Headers(headers) {
		    this.map = {};

		    if (headers instanceof Headers) {
		      headers.forEach(function(value, name) {
		        this.append(name, value);
		      }, this);
		    } else if (Array.isArray(headers)) {
		      headers.forEach(function(header) {
		        if (header.length != 2) {
		          throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
		        }
		        this.append(header[0], header[1]);
		      }, this);
		    } else if (headers) {
		      Object.getOwnPropertyNames(headers).forEach(function(name) {
		        this.append(name, headers[name]);
		      }, this);
		    }
		  }

		  Headers.prototype.append = function(name, value) {
		    name = normalizeName(name);
		    value = normalizeValue(value);
		    var oldValue = this.map[name];
		    this.map[name] = oldValue ? oldValue + ', ' + value : value;
		  };

		  Headers.prototype['delete'] = function(name) {
		    delete this.map[normalizeName(name)];
		  };

		  Headers.prototype.get = function(name) {
		    name = normalizeName(name);
		    return this.has(name) ? this.map[name] : null
		  };

		  Headers.prototype.has = function(name) {
		    return this.map.hasOwnProperty(normalizeName(name))
		  };

		  Headers.prototype.set = function(name, value) {
		    this.map[normalizeName(name)] = normalizeValue(value);
		  };

		  Headers.prototype.forEach = function(callback, thisArg) {
		    for (var name in this.map) {
		      if (this.map.hasOwnProperty(name)) {
		        callback.call(thisArg, this.map[name], name, this);
		      }
		    }
		  };

		  Headers.prototype.keys = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push(name);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.values = function() {
		    var items = [];
		    this.forEach(function(value) {
		      items.push(value);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.entries = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push([name, value]);
		    });
		    return iteratorFor(items)
		  };

		  if (support.iterable) {
		    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
		  }

		  function consumed(body) {
		    if (body._noBody) return
		    if (body.bodyUsed) {
		      return Promise.reject(new TypeError('Already read'))
		    }
		    body.bodyUsed = true;
		  }

		  function fileReaderReady(reader) {
		    return new Promise(function(resolve, reject) {
		      reader.onload = function() {
		        resolve(reader.result);
		      };
		      reader.onerror = function() {
		        reject(reader.error);
		      };
		    })
		  }

		  function readBlobAsArrayBuffer(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    reader.readAsArrayBuffer(blob);
		    return promise
		  }

		  function readBlobAsText(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
		    var encoding = match ? match[1] : 'utf-8';
		    reader.readAsText(blob, encoding);
		    return promise
		  }

		  function readArrayBufferAsText(buf) {
		    var view = new Uint8Array(buf);
		    var chars = new Array(view.length);

		    for (var i = 0; i < view.length; i++) {
		      chars[i] = String.fromCharCode(view[i]);
		    }
		    return chars.join('')
		  }

		  function bufferClone(buf) {
		    if (buf.slice) {
		      return buf.slice(0)
		    } else {
		      var view = new Uint8Array(buf.byteLength);
		      view.set(new Uint8Array(buf));
		      return view.buffer
		    }
		  }

		  function Body() {
		    this.bodyUsed = false;

		    this._initBody = function(body) {
		      /*
		        fetch-mock wraps the Response object in an ES6 Proxy to
		        provide useful test harness features such as flush. However, on
		        ES5 browsers without fetch or Proxy support pollyfills must be used;
		        the proxy-pollyfill is unable to proxy an attribute unless it exists
		        on the object before the Proxy is created. This change ensures
		        Response.bodyUsed exists on the instance, while maintaining the
		        semantic of setting Request.bodyUsed in the constructor before
		        _initBody is called.
		      */
		      // eslint-disable-next-line no-self-assign
		      this.bodyUsed = this.bodyUsed;
		      this._bodyInit = body;
		      if (!body) {
		        this._noBody = true;
		        this._bodyText = '';
		      } else if (typeof body === 'string') {
		        this._bodyText = body;
		      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
		        this._bodyBlob = body;
		      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
		        this._bodyFormData = body;
		      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		        this._bodyText = body.toString();
		      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
		        this._bodyArrayBuffer = bufferClone(body.buffer);
		        // IE 10-11 can't handle a DataView body.
		        this._bodyInit = new Blob([this._bodyArrayBuffer]);
		      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
		        this._bodyArrayBuffer = bufferClone(body);
		      } else {
		        this._bodyText = body = Object.prototype.toString.call(body);
		      }

		      if (!this.headers.get('content-type')) {
		        if (typeof body === 'string') {
		          this.headers.set('content-type', 'text/plain;charset=UTF-8');
		        } else if (this._bodyBlob && this._bodyBlob.type) {
		          this.headers.set('content-type', this._bodyBlob.type);
		        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
		        }
		      }
		    };

		    if (support.blob) {
		      this.blob = function() {
		        var rejected = consumed(this);
		        if (rejected) {
		          return rejected
		        }

		        if (this._bodyBlob) {
		          return Promise.resolve(this._bodyBlob)
		        } else if (this._bodyArrayBuffer) {
		          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
		        } else if (this._bodyFormData) {
		          throw new Error('could not read FormData body as blob')
		        } else {
		          return Promise.resolve(new Blob([this._bodyText]))
		        }
		      };
		    }

		    this.arrayBuffer = function() {
		      if (this._bodyArrayBuffer) {
		        var isConsumed = consumed(this);
		        if (isConsumed) {
		          return isConsumed
		        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
		          return Promise.resolve(
		            this._bodyArrayBuffer.buffer.slice(
		              this._bodyArrayBuffer.byteOffset,
		              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
		            )
		          )
		        } else {
		          return Promise.resolve(this._bodyArrayBuffer)
		        }
		      } else if (support.blob) {
		        return this.blob().then(readBlobAsArrayBuffer)
		      } else {
		        throw new Error('could not read as ArrayBuffer')
		      }
		    };

		    this.text = function() {
		      var rejected = consumed(this);
		      if (rejected) {
		        return rejected
		      }

		      if (this._bodyBlob) {
		        return readBlobAsText(this._bodyBlob)
		      } else if (this._bodyArrayBuffer) {
		        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
		      } else if (this._bodyFormData) {
		        throw new Error('could not read FormData body as text')
		      } else {
		        return Promise.resolve(this._bodyText)
		      }
		    };

		    if (support.formData) {
		      this.formData = function() {
		        return this.text().then(decode)
		      };
		    }

		    this.json = function() {
		      return this.text().then(JSON.parse)
		    };

		    return this
		  }

		  // HTTP methods whose capitalization should be normalized
		  var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE'];

		  function normalizeMethod(method) {
		    var upcased = method.toUpperCase();
		    return methods.indexOf(upcased) > -1 ? upcased : method
		  }

		  function Request(input, options) {
		    if (!(this instanceof Request)) {
		      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
		    }

		    options = options || {};
		    var body = options.body;

		    if (input instanceof Request) {
		      if (input.bodyUsed) {
		        throw new TypeError('Already read')
		      }
		      this.url = input.url;
		      this.credentials = input.credentials;
		      if (!options.headers) {
		        this.headers = new Headers(input.headers);
		      }
		      this.method = input.method;
		      this.mode = input.mode;
		      this.signal = input.signal;
		      if (!body && input._bodyInit != null) {
		        body = input._bodyInit;
		        input.bodyUsed = true;
		      }
		    } else {
		      this.url = String(input);
		    }

		    this.credentials = options.credentials || this.credentials || 'same-origin';
		    if (options.headers || !this.headers) {
		      this.headers = new Headers(options.headers);
		    }
		    this.method = normalizeMethod(options.method || this.method || 'GET');
		    this.mode = options.mode || this.mode || null;
		    this.signal = options.signal || this.signal || (function () {
		      if ('AbortController' in g) {
		        var ctrl = new AbortController();
		        return ctrl.signal;
		      }
		    }());
		    this.referrer = null;

		    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
		      throw new TypeError('Body not allowed for GET or HEAD requests')
		    }
		    this._initBody(body);

		    if (this.method === 'GET' || this.method === 'HEAD') {
		      if (options.cache === 'no-store' || options.cache === 'no-cache') {
		        // Search for a '_' parameter in the query string
		        var reParamSearch = /([?&])_=[^&]*/;
		        if (reParamSearch.test(this.url)) {
		          // If it already exists then set the value with the current time
		          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
		        } else {
		          // Otherwise add a new '_' parameter to the end with the current time
		          var reQueryString = /\?/;
		          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
		        }
		      }
		    }
		  }

		  Request.prototype.clone = function() {
		    return new Request(this, {body: this._bodyInit})
		  };

		  function decode(body) {
		    var form = new FormData();
		    body
		      .trim()
		      .split('&')
		      .forEach(function(bytes) {
		        if (bytes) {
		          var split = bytes.split('=');
		          var name = split.shift().replace(/\+/g, ' ');
		          var value = split.join('=').replace(/\+/g, ' ');
		          form.append(decodeURIComponent(name), decodeURIComponent(value));
		        }
		      });
		    return form
		  }

		  function parseHeaders(rawHeaders) {
		    var headers = new Headers();
		    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
		    // https://tools.ietf.org/html/rfc7230#section-3.2
		    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
		    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
		    // https://github.com/github/fetch/issues/748
		    // https://github.com/zloirock/core-js/issues/751
		    preProcessedHeaders
		      .split('\r')
		      .map(function(header) {
		        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
		      })
		      .forEach(function(line) {
		        var parts = line.split(':');
		        var key = parts.shift().trim();
		        if (key) {
		          var value = parts.join(':').trim();
		          try {
		            headers.append(key, value);
		          } catch (error) {
		            console.warn('Response ' + error.message);
		          }
		        }
		      });
		    return headers
		  }

		  Body.call(Request.prototype);

		  function Response(bodyInit, options) {
		    if (!(this instanceof Response)) {
		      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
		    }
		    if (!options) {
		      options = {};
		    }

		    this.type = 'default';
		    this.status = options.status === undefined ? 200 : options.status;
		    if (this.status < 200 || this.status > 599) {
		      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
		    }
		    this.ok = this.status >= 200 && this.status < 300;
		    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
		    this.headers = new Headers(options.headers);
		    this.url = options.url || '';
		    this._initBody(bodyInit);
		  }

		  Body.call(Response.prototype);

		  Response.prototype.clone = function() {
		    return new Response(this._bodyInit, {
		      status: this.status,
		      statusText: this.statusText,
		      headers: new Headers(this.headers),
		      url: this.url
		    })
		  };

		  Response.error = function() {
		    var response = new Response(null, {status: 200, statusText: ''});
		    response.ok = false;
		    response.status = 0;
		    response.type = 'error';
		    return response
		  };

		  var redirectStatuses = [301, 302, 303, 307, 308];

		  Response.redirect = function(url, status) {
		    if (redirectStatuses.indexOf(status) === -1) {
		      throw new RangeError('Invalid status code')
		    }

		    return new Response(null, {status: status, headers: {location: url}})
		  };

		  exports.DOMException = g.DOMException;
		  try {
		    new exports.DOMException();
		  } catch (err) {
		    exports.DOMException = function(message, name) {
		      this.message = message;
		      this.name = name;
		      var error = Error(message);
		      this.stack = error.stack;
		    };
		    exports.DOMException.prototype = Object.create(Error.prototype);
		    exports.DOMException.prototype.constructor = exports.DOMException;
		  }

		  function fetch(input, init) {
		    return new Promise(function(resolve, reject) {
		      var request = new Request(input, init);

		      if (request.signal && request.signal.aborted) {
		        return reject(new exports.DOMException('Aborted', 'AbortError'))
		      }

		      var xhr = new XMLHttpRequest();

		      function abortXhr() {
		        xhr.abort();
		      }

		      xhr.onload = function() {
		        var options = {
		          statusText: xhr.statusText,
		          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
		        };
		        // This check if specifically for when a user fetches a file locally from the file system
		        // Only if the status is out of a normal range
		        if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
		          options.status = 200;
		        } else {
		          options.status = xhr.status;
		        }
		        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
		        var body = 'response' in xhr ? xhr.response : xhr.responseText;
		        setTimeout(function() {
		          resolve(new Response(body, options));
		        }, 0);
		      };

		      xhr.onerror = function() {
		        setTimeout(function() {
		          reject(new TypeError('Network request failed'));
		        }, 0);
		      };

		      xhr.ontimeout = function() {
		        setTimeout(function() {
		          reject(new TypeError('Network request timed out'));
		        }, 0);
		      };

		      xhr.onabort = function() {
		        setTimeout(function() {
		          reject(new exports.DOMException('Aborted', 'AbortError'));
		        }, 0);
		      };

		      function fixUrl(url) {
		        try {
		          return url === '' && g.location.href ? g.location.href : url
		        } catch (e) {
		          return url
		        }
		      }

		      xhr.open(request.method, fixUrl(request.url), true);

		      if (request.credentials === 'include') {
		        xhr.withCredentials = true;
		      } else if (request.credentials === 'omit') {
		        xhr.withCredentials = false;
		      }

		      if ('responseType' in xhr) {
		        if (support.blob) {
		          xhr.responseType = 'blob';
		        } else if (
		          support.arrayBuffer
		        ) {
		          xhr.responseType = 'arraybuffer';
		        }
		      }

		      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
		        var names = [];
		        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
		          names.push(normalizeName(name));
		          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
		        });
		        request.headers.forEach(function(value, name) {
		          if (names.indexOf(name) === -1) {
		            xhr.setRequestHeader(name, value);
		          }
		        });
		      } else {
		        request.headers.forEach(function(value, name) {
		          xhr.setRequestHeader(name, value);
		        });
		      }

		      if (request.signal) {
		        request.signal.addEventListener('abort', abortXhr);

		        xhr.onreadystatechange = function() {
		          // DONE (success or failure)
		          if (xhr.readyState === 4) {
		            request.signal.removeEventListener('abort', abortXhr);
		          }
		        };
		      }

		      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
		    })
		  }

		  fetch.polyfill = true;

		  if (!g.fetch) {
		    g.fetch = fetch;
		    g.Headers = Headers;
		    g.Request = Request;
		    g.Response = Response;
		  }

		  exports.Headers = Headers;
		  exports.Request = Request;
		  exports.Response = Response;
		  exports.fetch = fetch;

		  return exports;

		}))({});
		})(__globalThis__);
		// This is a ponyfill, so...
		__globalThis__.fetch.ponyfill = true;
		delete __globalThis__.fetch.polyfill;
		// Choose between native implementation (__global__) or custom implementation (__globalThis__)
		var ctx = __global__.fetch ? __global__ : __globalThis__;
		exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
		exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
		exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
		exports.Headers = ctx.Headers;
		exports.Request = ctx.Request;
		exports.Response = ctx.Response;
		module.exports = exports; 
	} (browserPonyfill, browserPonyfill.exports));
	return browserPonyfill.exports;
}

var browserPonyfillExports = requireBrowserPonyfill();
var originalFetch = /*@__PURE__*/getDefaultExportFromCjs(browserPonyfillExports);

var fetchRetry_umd$1 = {exports: {}};

var fetchRetry_umd = fetchRetry_umd$1.exports;

var hasRequiredFetchRetry_umd;

function requireFetchRetry_umd () {
	if (hasRequiredFetchRetry_umd) return fetchRetry_umd$1.exports;
	hasRequiredFetchRetry_umd = 1;
	(function (module, exports) {
		(function (global, factory) {
		  module.exports = factory() ;
		})(fetchRetry_umd, (function () {
		  var fetchRetry = function (fetch, defaults) {
		    defaults = defaults || {};
		    if (typeof fetch !== 'function') {
		      throw new ArgumentError('fetch must be a function');
		    }

		    if (typeof defaults !== 'object') {
		      throw new ArgumentError('defaults must be an object');
		    }

		    if (defaults.retries !== undefined && !isPositiveInteger(defaults.retries)) {
		      throw new ArgumentError('retries must be a positive integer');
		    }

		    if (defaults.retryDelay !== undefined && !isPositiveInteger(defaults.retryDelay) && typeof defaults.retryDelay !== 'function') {
		      throw new ArgumentError('retryDelay must be a positive integer or a function returning a positive integer');
		    }

		    if (defaults.retryOn !== undefined && !Array.isArray(defaults.retryOn) && typeof defaults.retryOn !== 'function') {
		      throw new ArgumentError('retryOn property expects an array or function');
		    }

		    var baseDefaults = {
		      retries: 3,
		      retryDelay: 1000,
		      retryOn: [],
		    };

		    defaults = Object.assign(baseDefaults, defaults);

		    return function fetchRetry(input, init) {
		      var retries = defaults.retries;
		      var retryDelay = defaults.retryDelay;
		      var retryOn = defaults.retryOn;

		      if (init && init.retries !== undefined) {
		        if (isPositiveInteger(init.retries)) {
		          retries = init.retries;
		        } else {
		          throw new ArgumentError('retries must be a positive integer');
		        }
		      }

		      if (init && init.retryDelay !== undefined) {
		        if (isPositiveInteger(init.retryDelay) || (typeof init.retryDelay === 'function')) {
		          retryDelay = init.retryDelay;
		        } else {
		          throw new ArgumentError('retryDelay must be a positive integer or a function returning a positive integer');
		        }
		      }

		      if (init && init.retryOn) {
		        if (Array.isArray(init.retryOn) || (typeof init.retryOn === 'function')) {
		          retryOn = init.retryOn;
		        } else {
		          throw new ArgumentError('retryOn property expects an array or function');
		        }
		      }

		      // eslint-disable-next-line no-undef
		      return new Promise(function (resolve, reject) {
		        var wrappedFetch = function (attempt) {
		          // As of node 18, this is no longer needed since node comes with native support for fetch:
		          /* istanbul ignore next */
		          var _input =
		            typeof Request !== 'undefined' && input instanceof Request
		              ? input.clone()
		              : input;
		          fetch(_input, init)
		            .then(function (response) {
		              if (Array.isArray(retryOn) && retryOn.indexOf(response.status) === -1) {
		                resolve(response);
		              } else if (typeof retryOn === 'function') {
		                try {
		                  // eslint-disable-next-line no-undef
		                  return Promise.resolve(retryOn(attempt, null, response))
		                    .then(function (retryOnResponse) {
		                      if(retryOnResponse) {
		                        retry(attempt, null, response);
		                      } else {
		                        resolve(response);
		                      }
		                    }).catch(reject);
		                } catch (error) {
		                  reject(error);
		                }
		              } else {
		                if (attempt < retries) {
		                  retry(attempt, null, response);
		                } else {
		                  resolve(response);
		                }
		              }
		            })
		            .catch(function (error) {
		              if (typeof retryOn === 'function') {
		                try {
		                  // eslint-disable-next-line no-undef
		                  Promise.resolve(retryOn(attempt, error, null))
		                    .then(function (retryOnResponse) {
		                      if(retryOnResponse) {
		                        retry(attempt, error, null);
		                      } else {
		                        reject(error);
		                      }
		                    })
		                    .catch(function(error) {
		                      reject(error);
		                    });
		                } catch(error) {
		                  reject(error);
		                }
		              } else if (attempt < retries) {
		                retry(attempt, error, null);
		              } else {
		                reject(error);
		              }
		            });
		        };

		        function retry(attempt, error, response) {
		          var delay = (typeof retryDelay === 'function') ?
		            retryDelay(attempt, error, response) : retryDelay;
		          setTimeout(function () {
		            wrappedFetch(++attempt);
		          }, delay);
		        }

		        wrappedFetch(0);
		      });
		    };
		  };

		  function isPositiveInteger(value) {
		    return Number.isInteger(value) && value >= 0;
		  }

		  function ArgumentError(message) {
		    this.name = 'ArgumentError';
		    this.message = message;
		  }

		  return fetchRetry;

		})); 
	} (fetchRetry_umd$1));
	return fetchRetry_umd$1.exports;
}

var fetchRetry_umdExports = requireFetchRetry_umd();
var fetchRetry = /*@__PURE__*/getDefaultExportFromCjs(fetchRetry_umdExports);

var loggerProvider = function loggerProvider(_ref) {
  var name = _ref.name,
    debug = _ref.debug;
  return function (data) {
    if (debug) {
      console.log(name);
      console.log(data);
    }
  };
};

var fetch = fetchRetry(originalFetch);
var meta = function meta() {
  return {
    ts: Date.now(),
    rid: v4()
  };
};
var addMetadata = function addMetadata(payload) {
  var getMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : meta;
  return _objectSpread2(_objectSpread2({}, payload), {}, {
    meta: getMeta()
  });
};
var postEvent = function postEvent(_ref) {
  var logger = _ref.logger,
    url = _ref.url,
    _ref$decoratePayload = _ref.decoratePayload,
    decoratePayload = _ref$decoratePayload === void 0 ? addMetadata : _ref$decoratePayload;
  return function (payload) {
    var stringifiedPayload = JSON.stringify(decoratePayload(payload));
    logger("Payload: \n ".concat(stringifiedPayload));
    fetch(url, {
      method: 'post',
      body: stringifiedPayload,
      /* eslint-disable-next-line @typescript-eslint/naming-convention */
      headers: {
        'Content-Type': 'application/json'
      }
    })["catch"](function (err) {
      return logger("Error: \n ".concat(err));
    });
  };
};
var postFactory = function postFactory(url) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return postEvent({
    logger: loggerProvider({
      name: 'my-logger',
      debug: debug
    }),
    url: url
  });
};

var fetchUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    postEvent: postEvent,
    postFactory: postFactory
});

/**
 * Functions had to be extracted from the analytics library because we needed
 * the functionality but it was not exported.
 *
 * Taken from: https://github.com/DavidWells/analytics/blob/master/packages/analytics-core/src/modules/page.js#L54
 */

var hashRegex = /#.*$/;
var canonicalUrl = function canonicalUrl() {
  var tags = document.getElementsByTagName('link');
  for (var i = 0, tag; tag = tags[i]; i++) {
    if (tag.getAttribute('rel') === 'canonical') {
      return tag.getAttribute('href');
    }
  }
  return null;
};
var urlPath = function urlPath(url) {
  var regex = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g;
  var matches = regex.exec(url);
  var pathMatch = matches && matches[3] ? matches[3].split('?')[0].replace(hashRegex, '') : '';
  return '/' + pathMatch;
};
var currentUrl = function currentUrl(search) {
  var canonical = canonicalUrl();
  if (!canonical) {
    return window.location.href.replace(hashRegex, '');
  }
  return canonical.match(/\?/) ? canonical : canonical + search;
};
var getPageData = function getPageData() {
  var _document = document,
    title = _document.title,
    referrer = _document.referrer;
  var _window = window,
    location = _window.location,
    innerWidth = _window.innerWidth,
    innerHeight = _window.innerHeight;
  var hash = location.hash,
    search = location.search;
  var url = currentUrl(search);
  var page = {
    title: title,
    url: url,
    path: urlPath(url),
    hash: hash,
    search: search,
    width: innerWidth,
    height: innerHeight
  };
  if (referrer && referrer !== '') {
    page.referrer = referrer;
  }
  return page;
};
var getContext = function getContext() {
  return {
    page: getPageData(),
    userAgent: window.navigator.userAgent
  };
};

var pageDataUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getContext: getContext,
    getPageData: getPageData
});

var initializationConfig = function initializationConfig(_ref) {
  var idKey = _ref.idKey,
    userKey = _ref.userKey,
    url = _ref.url,
    debug = _ref.debug,
    local = _ref.local;
  return {
    getPageContext: getContext,
    postImpression: postFactory(url, debug),
    setId: setId(idKey, local),
    getId: getId(idKey),
    removeId: removeCookie(idKey, local),
    getUser: getUser(userKey),
    setUser: setUser(userKey),
    removeUser: removeCookie(userKey)
  };
};
var initialize = function initialize(_ref2) {
  var getId = _ref2.getId,
    setId = _ref2.setId;
  if (!getId()) {
    setId(v4());
  }
};

/**
 * Call to record a page view. Automatically records important page details.
 */
var page = function page(_ref3) {
  var getPageContext = _ref3.getPageContext,
    getId = _ref3.getId,
    postImpression = _ref3.postImpression,
    getUser = _ref3.getUser;
  return function () {
    var user = getUser();
    postImpression({
      properties: getPageContext().page,
      accountId: user ? user.accountId : undefined,
      anonymousId: getId(),
      context: getPageContext(),
      type: 'page'
    });
  };
};

/**
 * Call to send an event.
 * @param event - The event name.
 * @param version - The version of the event, such as v1, v2, v3, etc.
 * @param properties - Any data that goes along with the event.
 */
var track = function track(_ref4) {
  var getPageContext = _ref4.getPageContext,
    getId = _ref4.getId,
    postImpression = _ref4.postImpression,
    getUser = _ref4.getUser;
  return function (event) {
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'v0';
    var user = getUser();
    postImpression({
      properties: properties,
      accountId: user ? user.accountId : undefined,
      anonymousId: getId(),
      context: getPageContext(),
      type: 'track',
      event: event,
      version: version
    });
  };
};

/**
 * Call when a user gets a valid accountId.
 * @param accountId - The user's account id.
 * @param properties - Any user properties ex: loan type
 */
var identify = function identify(_ref5) {
  var getPageContext = _ref5.getPageContext,
    getId = _ref5.getId,
    postImpression = _ref5.postImpression,
    setUser = _ref5.setUser;
  return function (accountId) {
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setUser(accountId, properties);
    postImpression({
      properties: properties,
      accountId: accountId,
      anonymousId: getId(),
      context: getPageContext(),
      type: 'identify'
    });
  };
};
var createTrackingInstance = function createTrackingInstance(userConfig) {
  var url = userConfig.url,
    _userConfig$debug = userConfig.debug,
    debug = _userConfig$debug === void 0 ? false : _userConfig$debug,
    _userConfig$local = userConfig.local,
    local = _userConfig$local === void 0 ? false : _userConfig$local,
    _userConfig$idKey = userConfig.idKey,
    idKey = _userConfig$idKey === void 0 ? 'OU_1PT' : _userConfig$idKey,
    _userConfig$userKey = userConfig.userKey,
    userKey = _userConfig$userKey === void 0 ? 'OU_1PT_USER' : _userConfig$userKey,
    _userConfig$getInitia = userConfig.getInitializationConfig,
    getInitializationConfig = _userConfig$getInitia === void 0 ? initializationConfig : _userConfig$getInitia;
  var initConfig = getInitializationConfig({
    idKey: idKey,
    userKey: userKey,
    url: url,
    debug: debug,
    local: local
  });
  var getId = initConfig.getId,
    removeId = initConfig.removeId,
    getUser = initConfig.getUser,
    removeUser = initConfig.removeUser;
  initialize(initConfig);
  return {
    page: page(initConfig),
    track: track(initConfig),
    identify: identify(initConfig),
    reset: function reset() {
      if (getId()) {
        removeId();
      }
      if (getUser()) {
        removeUser();
      }
    },
    getAnonymousId: getId
  };
};

/* eslint-disable @typescript-eslint/naming-convention */
var trackingContext = createContext(createTrackingInstance({
  url: 'https://1pt.ownup.com',
  debug: true
}));
var TrackingProvider = trackingContext.Provider;
var useTrackingInstance = function useTrackingInstance() {
  var trackingInstance = useContext(trackingContext);
  return trackingInstance;
};

var utils = {
  cookies: cookieUtils,
  fetch: fetchUtils,
  page: pageDataUtils
};

export { TrackingProvider, createTrackingInstance, useTrackingInstance, utils };
//# sourceMappingURL=index.mjs.map
